export default (theme) => ({
    root: {},
    loader: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    expandedHeader: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '16px',
    },
    expandedContent: {
        width: '100%',
        height: 'calc(100% - 58px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    headerComponent: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexGrow: '1',
    },
    headerComponentContent: {
        paddingRight: '8px',
    },
});
